import script from "./QuickStartGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickStartGuide.vue?vue&type=script&setup=true&lang=js"

import "./QuickStartGuide.vue?vue&type=style&index=0&id=77f6022e&scoped=true&lang=postcss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f6022e"]])

export default __exports__